import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-white/60 bg-white/50 py-6">
      <div className="mx-auto max-w-6xl px-4 text-xs text-[var(--muted)]">
        Estimates are for informational purposes only and do not replace
        professional medical advice.
        <div className="mt-2">
          {"\u00a9"} 2026 BetterBMRCalculator. All rights reserved.
        </div>
        <div className="mt-3 flex flex-wrap items-center gap-3 text-[var(--muted)]">
          <Link
            className="inline-flex items-center gap-2 rounded-full border border-white/60 bg-white/70 px-3 py-1 text-[var(--ink)] transition hover:border-white/80"
            to="/privacy"
          >
            <span>Privacy</span>
          </Link>
          <a
            className="inline-flex items-center gap-2 rounded-full border border-white/60 bg-white/70 px-3 py-1 text-[var(--ink)] transition hover:border-white/80"
            href="https://www.linkedin.com/in/maxwellmcinnis/"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn profile"
          >
            <svg
              className="h-4 w-4"
              viewBox="0 0 24 24"
              role="img"
              aria-hidden="true"
              focusable="false"
            >
              <path
                fill="currentColor"
                d="M4.98 3.5C3.88 3.5 3 4.38 3 5.48c0 1.08.86 1.96 1.96 1.96h.02c1.1 0 1.98-.88 1.98-1.96C6.96 4.38 6.08 3.5 4.98 3.5zM3.5 8.75h2.96v11H3.5v-11zm7.37 0h2.84v1.5h.04c.39-.74 1.33-1.52 2.74-1.52 2.93 0 3.47 1.92 3.47 4.42v6.6h-2.96v-5.86c0-1.4-.03-3.2-1.95-3.2-1.95 0-2.25 1.52-2.25 3.09v5.97h-2.96v-11z"
              />
            </svg>
            <span>LinkedIn</span>
          </a>
          <a
            className="inline-flex items-center gap-2 rounded-full border border-white/60 bg-white/70 px-3 py-1 text-[var(--ink)] transition hover:border-white/80"
            href="https://github.com/MaxwellM34"
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub profile"
          >
            <svg
              className="h-4 w-4"
              viewBox="0 0 24 24"
              role="img"
              aria-hidden="true"
              focusable="false"
            >
              <path
                fill="currentColor"
                d="M12 2C6.48 2 2 6.58 2 12.24c0 4.5 2.87 8.32 6.84 9.67.5.1.68-.22.68-.48 0-.24-.01-.86-.01-1.69-2.78.62-3.37-1.36-3.37-1.36-.45-1.18-1.11-1.5-1.11-1.5-.9-.64.07-.63.07-.63 1 .07 1.53 1.06 1.53 1.06.9 1.56 2.36 1.11 2.94.85.09-.67.35-1.11.63-1.36-2.22-.26-4.56-1.14-4.56-5.05 0-1.11.39-2.02 1.02-2.73-.1-.26-.44-1.31.1-2.73 0 0 .83-.27 2.73 1.04.79-.23 1.64-.35 2.49-.35.85 0 1.7.12 2.49.35 1.9-1.31 2.73-1.04 2.73-1.04.54 1.42.2 2.47.1 2.73.63.71 1.02 1.62 1.02 2.73 0 3.92-2.35 4.79-4.58 5.04.36.32.68.95.68 1.92 0 1.39-.01 2.51-.01 2.85 0 .26.18.58.69.48 3.96-1.35 6.82-5.17 6.82-9.67C22 6.58 17.52 2 12 2z"
              />
            </svg>
            <span>GitHub</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
